import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleColorDto } from './create-vehicle-color.dto';

/**
 * Update vehicle color DTO
 */
export class UpdateVehicleColorDto extends CreateVehicleColorDto {
	@TransformInt()
	id!: number;
}
